import { createStyles, Text } from "@mantine/core";
import { PropsWithChildren } from "react";

const useHeaderStyles = createStyles((theme) => ({
  title: {
    fontFamily: theme.headings.fontFamily,
    fontWeight: theme.other.fontWeights.semibold,
    fontSize: theme.fontSizes.xl,
    lineHeight: theme.headings.sizes.h3.lineHeight,
    fontFeatureSettings: '"liga" off, "clig" off',
    textAlign: "center",
  },

  subTitle: {
    fontWeight: theme.other.fontWeights.normal,
    fontSize: theme.fontSizes.lg,
  },
}));

export function RpiTitle({ children }: PropsWithChildren) {
  const { classes } = useHeaderStyles();
  return <Text className={classes.title}>{children}</Text>;
}

export function RpiSubTitle({ children }: PropsWithChildren) {
  const { classes } = useHeaderStyles();
  return <Text className={`${classes.title} ${classes.subTitle}`}>{children}</Text>;
}
